import { useState } from 'react';
import {Box, Divider } from '@mui/material';
import CalendarWithAppointments from './Calendar';
import CalendarAppBar from './CalendarCustomAppBar';
import DrawerSidebar from './AppointmentDrawer';


interface CalendarEvent {
  id: string;
  title: string;
  start: string;
  description?: string;
  origin: "internal" | "google";
  status?: string;
  property?: string;
  agent?: string;
  notes?: string;
}

const DashboardCitas = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <CalendarAppBar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      
      <DrawerSidebar
        open={drawerOpen}
        onToggle={() => setDrawerOpen(!drawerOpen)}
        events={events}
        onSelectEvent={(event) => {
          setSelectedEvent(event);
          setModalOpen(true);
        }}
      />
      <Box
        display="flex"
        justifyContent="center"
        sx={{

          mt: '10vh',
          ml: drawerOpen ? '320px' : 'auto',
          mr: drawerOpen ? 0 : 'auto',
          px: 2,
          pb: 4,
          overflowX: 'hidden',
          minHeight: 'calc(100vh - 64px)',
          transition: 'all 0.3s ease',
        }}
      >

        <Divider key="divider2" />

        <CalendarWithAppointments
          events={events}
          setEvents={setEvents}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
        />

      </Box>
    </>
  );
}; export default DashboardCitas;
